import { connect } from 'react-redux';
import { restrictLoggedOut } from '../../../../redux/loggedout';
import { focusEditor } from '../../../../CommentBox/actionCreators';
import { canAutoOpenReplyForm } from '../selectors';
var mapStateToProps = function (state, props) { return ({
    canAutoOpenReplyForm: !!props.canAutoOpenReplyForm &&
        canAutoOpenReplyForm(state, props.commentId),
}); };
var mapDispatchToProps = {
    focusEditor: focusEditor,
    restrictLoggedOut: restrictLoggedOut,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ReplyButton.container.js.map